export type CompanyModuleKey =
  | 'dashboard'
  | 'positions'
  | 'guards'
  | 'devices'
  | 'users'
  | 'checkins'
  | 'accessRequests'
  | 'supervision'
  | 'schedules'
  | 'patrols';

export type CompanyDashboardCardKey =
  | 'checkins'
  | 'positions'
  | 'guards'
  | 'devices'
  | 'supervisors'
  | 'users'
  | 'requests'
  | 'positionsCheckinsTable'
  | 'patrols'
  | 'connections'
  |'establishment'
  | 'vehicles'
  | 'accessrecord';
export type CompanyServiceKey =
  | 'pushNotifications'
  | 'scheduleManager'
  | 'excelImport'
  | 'notificationScheduler';

export type CompanyMobileKey =
  | 'guardCheckin'
  | 'guardCheckinGpsRequired'
  | 'guardCheckinPhotoRequired'
  | 'patrols'
  | 'patrolsGpsRequired'
  | 'patrolsPhotoRequired'
  | 'patrolsAllowSkipCheckpoint'
  | 'supervisor'
  | 'supervisorCheckin'
  | 'supervisorMessages'
  | 'supervisorNotifications'
  | 'accessControl';

export interface CompanyConfig {
  company_id: number | string;
  modules: Record<CompanyModuleKey, boolean>;
  dashboard_cards: Record<CompanyDashboardCardKey, boolean>;
  services: Record<CompanyServiceKey, boolean>;
  mobile: Record<CompanyMobileKey, boolean>;
  metadata?: {
    updated_at?: string;
    updated_by?: string;
  };
}

export const createDefaultCompanyConfig = (companyId: number | string = 0): CompanyConfig => ({
  company_id: companyId,
  modules: {
    dashboard: true,
    positions: true,
    guards: true,
    devices: true,
    users: true,
    checkins: true,
    accessRequests: true,
    supervision: true,
    schedules: true,
    patrols: true,
  },
  dashboard_cards: {
    checkins: true,
    positions: true,
    guards: true,
    devices: true,
    supervisors: true,
    users: true,
    requests: true,
    positionsCheckinsTable: true,
    patrols: true,
    connections:false,
    establishment:false,
    accessrecord:false,
    vehicles:false
  },
  services: {
    pushNotifications: true,
    scheduleManager: true,
    excelImport: true,
    notificationScheduler: true,
  },
  mobile: {
    guardCheckin: true,
    guardCheckinGpsRequired: true,
    guardCheckinPhotoRequired: false,
    patrols: true,
    patrolsGpsRequired: true,
    patrolsPhotoRequired: false,
    patrolsAllowSkipCheckpoint: false,
    supervisor: true,
    supervisorCheckin: true,
    supervisorMessages: true,
    supervisorNotifications: true,
    accessControl: true,
  },
  metadata: {
    updated_at: undefined,
    updated_by: undefined,
  },
});
